import { $post } from '@/api'
import { IShopConfig, IShopInfo } from '@/model/types/shop'
import { IPagination } from '@/model/types/common'

export interface ICashierSeat {
    cashier_sn: string
    occupier_staff?: {
        id: number
        user?: {
            id: number
            nickname: string
            realname: string
            avatar: string
        }
    } | null
}

export interface ISecondaryScreenNotice {
    id: number
    qiniu_key: string
    notice_type: number
    notice_source: number
}

export interface ISecondaryScreenNoticeResponse {
    image_notices: ISecondaryScreenNotice[]
    video_notices: ISecondaryScreenNotice[]
}

export interface IReceiptPrintConfig {
    attach_text?: string
    attach_img_url?: string
}

export interface ICashierSeatPayInfo {
    fee_infos?: Array<{
        fee_code: number
        price: number
        status: number
    }>
}

export interface ICustomPayment {
    id: number
    name: string
    status: number
    can_delete: boolean
}

export interface IShopPayment {
    paymentconfig: { payment_list: number[] }
    custom_payment_config: ICustomPayment[]
}

/** 店铺信息 */
export const getShopInfo = () =>
    $post<IShopInfo, undefined>({
        url: '/shop/getshopinfo',
    })

export const editShopInfo = (
    params: Partial<{
        shop_name: string
        phone: string
        description: string
        logo_image_url: string
        bussiness_license_url: string
        bussiness_permission_url: string
        show_bussiness: boolean
        district_code: number
        detailed_address: string
        longitude: number
        latitude: number
    }>,
) =>
    $post<void, typeof params>({
        url: '/shop/editshopinfo',
        params,
    })

/** 收银台设置 */
export const getShopConfig = () =>
    $post<IShopConfig, undefined>({
        url: '/shop/getshopconfig',
    })

export const updateShopConfig = (params: Partial<IShopConfig>) =>
    $post<void, Partial<IShopConfig>>({
        url: '/shop/updateshopconfig',
        params,
    })

export const getShopPayment = () =>
    $post<IShopPayment, undefined>({
        url: '/shop/getshoppayment',
    })

export const editShopPayment = (payment: number, status: number) =>
    $post<void, { payment: number; status: number }>({
        url: '/shop/editpaymentconfig',
        params: { payment, status },
    })

export const editCustomPayment = (params: { custom_paymentconfig_id?: number; name?: string; status?: number }) =>
    $post<void, typeof params>({
        url: '/shop/editcustompaymentconfig',
        params,
    })

export const getCashierSeatOccupation = (page: number, limit: number) =>
    $post<{ data_list: ICashierSeat[]; pagination: IPagination }, { page: number; limit: number }>({
        url: '/shop/cashierseatoccupation',
        params: { page, limit },
    })

export const getCashierSeatPayInfo = () =>
    $post<ICashierSeatPayInfo, undefined>({
        url: '/valueaddedservices/cashierseatpayinfo',
    })

export const makeStaffOffline = (cashier_sn: string, staff_id: number) =>
    $post<void, { cashier_sn: string; staff_id: number }>({
        url: '/ws/makestaffoffline',
        params: { cashier_sn, staff_id },
    })

/** 副屏公告 */
export const getSecondaryScreenNotice = () =>
    $post<ISecondaryScreenNoticeResponse, undefined>({
        url: '/shop/getsecondaryscreennotice',
    })

export const addSecondaryScreenNotice = (params: {
    secondary_screen_notice_list: Array<{
        qiniu_key: string
        notice_type: number
        material_info: {
            uid: string
            material_type: number
            name: string
            url: string
            size: number
            duration: number | null
            proportion: string | null
        }
    }>
}) =>
    $post<void, typeof params>({
        url: '/shop/addsecondaryscreennotice',
        params,
    })

export const deleteSecondaryScreenNotice = (params: { secondary_screen_notice_id: number }) =>
    $post<void, typeof params>({
        url: '/shop/deletesecondaryscreennotice',
        params,
    })

/** 小票打印设置 */
export const getReceiptPrintConfig = () =>
    $post<IReceiptPrintConfig, undefined>({
        url: '/shop/getreceiptprintconfig',
    })

export const updateReceiptPrintConfig = (
    params: Partial<{
        attach_text: string
        attach_img_url: string
    }>,
) =>
    $post<void, typeof params>({
        url: '/shop/updatereceiptprintconfig',
        params,
    })
